document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.harajuku-lot1__slider').forEach((sliderWrap) => {
    const swiperElement = sliderWrap.querySelector('.swiper'); 
    const paginationElement = sliderWrap.querySelector('.swiper-pagination'); 
    const nextButton = sliderWrap.querySelector('.swiper-button-next'); 
    const prevButton = sliderWrap.querySelector('.swiper-button-prev'); 

    new Swiper(swiperElement, {
      loop: false, 
      speed: 300, 
      pagination: {
        el: paginationElement,
        clickable: true,
        type: 'bullets', 
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
        disabledClass: 'swiper-button-disabled',
        hideOnClick: false,
      },
    });
  });
});